import _ from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getAssignUserReq,
  getAssignUserResponseClear,
  getTeamMatesReq,
  getTeamMatesResClear,
  setCurrentView,
} from "../../redux/assignCourse/actions";
import { SessionKeys } from "../../utils/AppUtils";
import CONFIG from "../../utils/config";
import StaticUtils from "../../utils/StaticUtils";
import { useTranslation } from "react-i18next";
const ChooseTeammateForTeam = (props) => {
  const {
    selectedTeamMatesList,
    setSelectedTeamMatesList,
    setFilteredFromCoursesOffices,
    parentId,
    parentName,
    setTitleHeading,
    setIsByNameTeam,
    fromMyTeams,
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { courseId } = useParams();
  const teamMatesListRes = useSelector(
    (state) => state.assignCourse.teamMatesList
  );
  const assignedUserRes = useSelector(
    (state) => state.assignCourse.assignedUsers
  );
  const [searchInput, setSearchInput] = useState("");
  const [teamMatesList, setTeamMatesList] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [contentType, setContentType] = useState("");
  const [isLoaded, setisLoaded] = useState(false);

  useEffect(() => {
    setSelectedTeamMatesList([]);
    setFilteredFromCoursesOffices([]);
  }, []);

  useEffect(() => {
    if (parentName) {
      if (parentName.toLowerCase().includes("event")) {
        setContentType("session");
      } else if (parentName.toLowerCase().includes("certificate")) {
        setContentType("certificate");
      } else if (parentName.toLowerCase().includes("Action Path")) {
        setContentType("learningpath");
      } else if (parentName.toLowerCase().includes("onboarding path")) {
        setContentType("onboardingpath");
      } else {
        setContentType(parentName.toLowerCase());
      }
    }
  }, [parentName]);

  useEffect(() => {
    if (fromMyTeams) {
      setTitleHeading(`${t("Create a Team")}`); // ${parentName} ${t("to")}
    } else {
      setTitleHeading(`${t("Assign")} ${parentName} ${t("to")}`);
    }
    dispatch(getTeamMatesResClear());
    if (!_.isEmpty(contentType)) getAssignedUsers();

    return () => {
      dispatch(getAssignUserResponseClear());
    };
  }, [contentType]);

  useEffect(() => {
    setSelectedCount(selectedTeamMatesList?.length);
  }, [selectedTeamMatesList]);

  useEffect(() => {
    if (searchInput !== undefined && searchInput.length > 2)
      getTeamMatesOnSearch();
  }, [searchInput]);

  const getTeamMatesOnSearch = () => {
    setisLoaded(false);
    dispatch(
      getTeamMatesReq({
        module: "getTeamMatesList",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          search: searchInput,
          content_type: contentType,
          content_ids: [parentId],
        },
      })
    );
  };

  useEffect(() => {
    // console.log("teamMatesListRes: ", teamMatesListRes);
    if (!_.isEmpty(teamMatesListRes)) {
      if (teamMatesListRes?.status === "success") {
        setTeamMatesList(teamMatesListRes?.payload?.payload);
        if (teamMatesListRes?.payload?.payload.length === 0) {
          setisLoaded(true);
        }
      } else {
        setTeamMatesList([]);
        setisLoaded(true);
      }
    } else {
      setTeamMatesList([]);
    }
  }, [teamMatesListRes]);

  const getAssignedUsers = () => {
    dispatch(
      getAssignUserReq({
        module: "getAssignedUsers",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          content_type: contentType,
          content_ids: [parentId],
          type: "teammates",
        },
      })
    );
  };

  useEffect(() => {
    // console.log("teamMatesListRes: ", teamMatesListRes);
    if (!_.isEmpty(assignedUserRes)) {
      if (assignedUserRes?.status === "success") {
        setAssignedUsers(assignedUserRes?.payload?.payload);
      }
    } else {
      setAssignedUsers([]);
    }
  }, [assignedUserRes]);

  const selectItem = (index) => {
    let tempArr = _.cloneDeep(teamMatesList);
    let selectedTempArray = _.cloneDeep(selectedTeamMatesList);
    if (!StaticUtils.isContainObject(selectedTempArray, tempArr[index], 0)) {
      selectedTempArray.push(tempArr[index]);
    }

    setSelectedTeamMatesList(selectedTempArray);
    setFilteredFromCoursesOffices(selectedTempArray);
    tempArr.splice(index, 1);
    setTeamMatesList(tempArr);
  };

  const removeItem = (index) => {
    let selectedTempArray = _.cloneDeep(selectedTeamMatesList);
    let tempArr = _.cloneDeep(teamMatesList);

    if (!StaticUtils.isContainObject(tempArr, selectedTempArray[index], 0)) {
      tempArr.push(selectedTempArray[index]);
    }

    setTeamMatesList(tempArr);
    selectedTempArray.splice(index, 1);
    setSelectedTeamMatesList(selectedTempArray);
    setFilteredFromCoursesOffices(selectedTempArray);
  };

  return (
    <>
      <div className="chooseteamate">
        {fromMyTeams ? "" : <h4>{t("Choose Agents")}</h4>}
        <div className="input-lear position-relative d-flex">
          <label for="teamsearch" className="input__label">
            {fromMyTeams ? t("Search for participants") : t("Search")}
          </label>
          <input
            type="text"
            id="teamsearch"
            name="teamsearch"
            className="input_searchfield_search-cart "
            placeholder={t("Start searching")}
            onChange={(evt) => {
              setSearchInput(evt.target.value);
            }}
          />
        </div>
        {searchInput.length > 2 && teamMatesList.length === 0 && isLoaded ? (
          <span style={{ color: "red" }}>
            {t("No results found with")} "{searchInput}"
          </span>
        ) : (
          ""
        )}
        <div className="search-team-result">
          {teamMatesList?.map((item, index) => {
            return (
              <div className="team-result-box">
                <div className="team-user-img">
                  <img
                    src={
                      item?.profile_img !== ""
                        ? item?.profile_img
                        : CONFIG.DEFAULT_AVATAR
                    }
                    alt="user"
                  />
                </div>
                <div className="userteamname">{item?.name}</div>
                <div
                  className="addteammate cursor-pointer"
                  onClick={() => {
                    selectItem(index);
                  }}
                >
                  +
                </div>
              </div>
            );
          })}
        </div>
        <div className="teamselected">
          <div className="selectresilt">
            {t("Selected Participants")}
            <strong>({selectedCount})</strong>
          </div>
          <div className="search-team-result slectedteammates">
            {selectedTeamMatesList?.map((item, index) => {
              return (
                <div className="team-result-box">
                  <div className="team-user-img">
                    <img
                      src={
                        item?.profile_img !== ""
                          ? item?.profile_img
                          : "/images/avatar.svg"
                      }
                      alt="user"
                    />
                  </div>
                  <div className="userteamname">{item?.name}</div>
                  <div
                    className="addteammate cursor-pointer"
                    onClick={() => {
                      //   console.log("removeItem");
                      removeItem(index);
                    }}
                  >
                    +
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="buttonsteammate">
          {fromMyTeams ? (
            ""
          ) : (
            <button
              type="button"
              className="btn btn-primary btn-block back-button"
              onClick={() => {
                dispatch(setCurrentView(5));
              }}
            >
              {t("back")}
            </button>
          )}
          {selectedCount > 0 ? (
            <button
              type="button"
              className="btn btn-primary btn-block setup-button"
              onClick={() => {
                setIsByNameTeam(true);
                dispatch(setCurrentView(4));
              }}
            >
              {t("proceed")}
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-primary btn-block setup-button"
              disabled
            >
              {t("proceed")}
            </button>
          )}
        </div>

        {fromMyTeams ? (
          ""
        ) : (
          <div className="teamselected">
            <div className="selectresilt">
              {t("Assigned Agents")}
              <strong>({assignedUsers?.length})</strong>
            </div>
            <div className="search-team-result slectedteammates">
              {assignedUsers?.map((item, index) => {
                return (
                  <div className="team-result-box">
                    <div className="team-user-img">
                      <img
                        src={
                          item?.profile_img !== ""
                            ? item?.profile_img
                            : "/images/avatar.svg"
                        }
                        alt="user"
                      />
                    </div>
                    <div className="userteamname">{item?.name}</div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ChooseTeammateForTeam;
